<template>
  <div class="filter-container">
    <div class="filter-item">
      <label>年份</label>
      <div class="filter-select">
        <div
          v-for="(item, index) in yearList"
          :key="index"
          class="select-item"
          :data-actived="item === currentYear"
          @click="changeYear(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="filter-item">
      <label>直播</label>
      <div class="filter-select">
        <div
          v-for="item in typeList"
          :key="item.id"
          class="select-item"
          :data-actived="item.id === currentType.id"
          @click="changeType(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="filter-item">
      <label>状态</label>
      <div class="filter-select">
        <div
          v-for="item in statusList"
          :key="item.id"
          class="select-item"
          :data-actived="item.id === currentStatus.id"
          @click="changeStatus(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    typeList: {
      type: Array,
      default: () => [],
    },
    yearList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentType: {
        id: 0,
        name: '全部',
      },
      currentYear: '全部',
      currentStatus: {
        id: 0,
        name: '全部',
      },
      statusList: [
        {
          id: 0,
          name: '全部',
        },
        {
          id: 2,
          name: '未开始',
        },
        {
          id: 3,
          name: '直播中',
        },
        {
          id: 1,
          name: '已结束',
        },
      ],
    }
  },
  methods: {
    changeType(item) {
      this.currentType = item
      this.filter()
    },
    changeYear(item) {
      this.currentYear = item
      this.filter()
    },
    changeStatus(item) {
      this.currentStatus = item
      this.filter()
    },
    filter() {
      const form = {
        year: this.currentYear === '全部' ? '' : this.currentYear,
        type: this.currentType.id,
        status: this.currentStatus.id === 0 ? '' : this.currentStatus.id,
      }
      this.$emit('search', form)
    },
  },
}
</script>
<style lang="less" scoped>
.filter-container {
  width: 100%;
  padding: 30px 20px;

  .filter-item {
    padding: 10px 0;
    display: flex;
    gap: 20px;

    label {
      width: 40px;
      font-size: 18px;
      line-height: 34px;
      font-weight: bold;
    }

    .filter-select {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      .select-item {
        width: fit-content;
        padding: 0 16px;
        height: 34px;
        border-radius: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333333;
        background-color: #ffffff;
        cursor: pointer;

        &[data-actived='true'] {
          background: linear-gradient(80.24deg,#336aff 8.77%,#0adcf2 162.95%);
          color: #ffffff;
        }
      }
    }
  }
}
</style>
